import { createAction, props } from "@ngrx/store";

export const setPermissions = createAction(
  'User.SetPermissions',
  props<{
    permissions: string[];
    isAuthenticated: boolean;
  }>()
);
